export default "__VITE_ASSET__C3sDY495__"